import { t } from "i18next";

export const DEFAULT_DEVICES = [
  {
    label: t("neetoMolecules.insights.labels.devices.desktop"),
    value: "desktop",
  },
  {
    label: t("neetoMolecules.insights.labels.devices.mobile"),
    value: "smartphone",
  },
];

export const DEFAULT_OS = [
  { label: t("neetoMolecules.insights.labels.os.macos"), value: "mac" },
  {
    label: t("neetoMolecules.insights.labels.os.windows"),
    value: "windows",
  },
];

export const DEFAULT_BROWSERS = [
  {
    label: t("neetoMolecules.insights.labels.browsers.chrome"),
    value: "chrome",
  },
  {
    label: t("neetoMolecules.insights.labels.browsers.safari"),
    value: "safari",
  },
];

export const INITIAL_TIME_PERIOD_VALUE = {
  label: t("neetoMolecules.insights.labels.allTime"),
  value: { startDate: null, endDate: null, rangeType: "all" },
};
